<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title>原因</v-card-title>
      <v-card-text>
        <v-textarea outlined autofocus v-model="reason"></v-textarea>
        <slot></slot>
        <v-btn 
          block 
          color="pink" 
          :dark="!!reason"
          :disabled="!reason"
          @click="func(reason); dialog = false"
        >
          送出
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      reason: '',
      func: null,
    }
  },
  watch: {
    dialog() {
      this.reason = ''
    },
  },
  methods: {
    submit(func) {
      this.dialog = true
      this.func = func
    }
  }
}
</script>